export default "__VITE_ASSET__DsY3UGz7__"